import { render } from "./kalio-carousel.vue?vue&type=template&id=3f4d3904"
import script from "./kalio-carousel.vue?vue&type=script&lang=js"
export * from "./kalio-carousel.vue?vue&type=script&lang=js"

import "./kalio-carousel.vue?vue&type=style&index=0&id=3f4d3904&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__